<template>
    <AppMainSearchCard :tituloTela="tituloTela" :canDelete="false" :canSearch="false" :isSearch="true" :isLoading="isLoadinglotesProducao"
        :canAdd="false">

        <v-layout row wrap justify-center pa-3 pl-5 pr-5>
            <v-flex sm11 xs11 md12 lg12>
                <v-expansion-panels>
                    <v-expansion-panel :key="loteProducaoStore.idLoteProducao">
                        <v-expansion-panel-header>
                            <div class="text-start">
                                <v-badge color="accent" top >
                                    <template v-slot:badge>
                                        <span style="color: darkslategray;">{{totalInputs}}</span>
                                    </template>
                                    <h2>Alojamentos</h2>
                                </v-badge>
                            </div>
                            <v-spacer/>
                            <v-layout row wrap justify-end mr-1>
                                <v-btn id="adicionarEntradaAnimais" fab small dark color="#10303D" @click.prevent.stop="novaEntradaAnimais" style="margin:2px;">
                                    <v-icon dark small>fas fa-plus</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-layout row wrap justify-center>
                                <v-flex sm11 xs11 md12 lg12>
                                    <v-data-table :headers="headersEntradasAnimais" no-results-text="Nenhum registro encontrado"  @click:row="editEntradaAnimais"
                                        :items="inputs" color="secondary" loading-text="Carregando registros...aguarde">
                                        <template v-slot:item.dtEntrada="{ item }">
                                            {{ item.dtEntrada | dateIsoToLocale }}
                                        </template>
                                        <template v-slot:item.dtGta="{ item }">
                                            {{ item.dtGta | dateIsoToLocale }}
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-center pa-3 pl-5 pr-5>
            <v-flex sm11 xs11 md12 lg12>
                <v-expansion-panels>
                    <v-expansion-panel :key="loteProducaoStore.idLoteProducao">
                        <v-expansion-panel-header>
                            <div class="text-start">
                                <v-badge color="accent" top >
                                    <template v-slot:badge>
                                        <span style="color: darkslategray;">{{totalRation}}</span>
                                    </template>
                                    <h2>Entradas de Ração</h2>
                                </v-badge>
                            </div>
                            <v-spacer/>
                            <v-layout row wrap justify-end mr-1>
                                <v-btn id="adicionarEntradaRacao" fab small dark color="#10303D" @click.prevent.stop="novaEntradaRacao" style="margin:2px;">
                                    <v-icon dark small>fas fa-plus</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-layout row wrap justify-center>
                                <v-flex sm11 xs11 md12 lg12>
                                    <v-data-table :headers="headersEntradasRacao" no-results-text="Nenhum registro encontrado"  @click:row="editEntradaRacao"
                                        :items="ration" color="secondary" loading-text="Carregando registros...aguarde">
                                        <template v-slot:item.dtEntrada="{ item }">
                                            {{ item.dtEntrada | dateIsoToLocale }}
                                        </template>
                                        <template v-slot:item.dtInicioConsumo="{ item }">
                                            {{ item.dtInicioConsumo | dateIsoToLocale }}
                                        </template>
                                        <template v-slot:item.dtFimConsumo="{ item }">
                                            {{ item.dtFimConsumo | dateIsoToLocale }}
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-center pa-3 pl-5 pr-5>
            <v-flex sm11 xs11 md12 lg12>
                <v-expansion-panels>
                    <v-expansion-panel :key="loteProducaoStore.idLoteProducao">
                        <v-expansion-panel-header>
                            <div class="text-start">
                                <v-badge color="accent" top >
                                    <template v-slot:badge>
                                        <span style="color: darkslategray;">{{totalDeaths}}</span>
                                    </template>
                                    <h2>Mortalidades</h2>
                                </v-badge>
                            </div>
                            <v-spacer/>
                            <v-layout row wrap justify-end mr-1>
                                <v-btn id="adicionarMortalidade" fab small dark color="#10303D" @click.prevent.stop="novaMortalidade" style="margin:2px;">
                                    <v-icon dark small>fas fa-plus</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-layout row wrap justify-center>
                                <v-flex sm11 xs11 md12 lg12>
                                    <v-data-table :headers="headersMortalidades" no-results-text="Nenhum registro encontrado"  @click:row="editMortalidade"
                                        :items="deaths" color="secondary" loading-text="Carregando registros...aguarde">
                                        <template v-slot:item.dtBaixa="{ item }">
                                            {{ item.dtBaixa | dateIsoToLocale }}
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-center pa-3 pl-5 pr-5>
            <v-flex sm11 xs11 md12 lg12>
                <v-expansion-panels>
                    <v-expansion-panel :key="loteProducaoStore.idLoteProducao">
                        <v-expansion-panel-header>
                            <div class="text-start">
                                <v-badge color="accent" top >
                                    <template v-slot:badge>
                                        <span style="color: darkslategray;">{{totalMedicines}}</span>
                                    </template>
                                    <h2>Medicamentos</h2>
                                </v-badge>
                            </div>
                            <v-spacer/>
                            <v-layout row wrap justify-end mr-1>
                                <v-btn id="adicionarMedicamento" fab small dark color="#10303D" @click.prevent.stop="novoMedicamento" style="margin:2px;">
                                    <v-icon dark small>fas fa-plus</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-layout row wrap justify-center>
                                <v-flex sm11 xs11 md12 lg12>
                                    <v-data-table :headers="headersMedicines" no-results-text="Nenhum registro encontrado"  @click:row="editMedicamento"
                                        :items="medicines" color="secondary" loading-text="Carregando registros...aguarde">
                                        <template v-slot:item.dtInicioTratamento="{ item }">
                                            {{ item.dtInicioTratamento | dateIsoToLocale }}
                                        </template>
                                        <template v-slot:item.dtFimTratamento="{ item }">
                                            {{ item.dtFimTratamento | dateIsoToLocale }}
                                        </template>
                                        <template v-slot:item.dtCarencia="{ item }">
                                            {{ item.dtCarencia | dateIsoToLocale }}
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-center pa-3 pl-5 pr-5>
            <v-flex sm11 xs11 md12 lg12>
                <v-expansion-panels>
                    <v-expansion-panel :key="loteProducaoStore.idLoteProducao">
                        <v-expansion-panel-header>
                            <div class="text-start">
                                <v-badge color="accent" top >
                                    <template v-slot:badge>
                                        <span style="color: darkslategray;">{{totalOutputs}}</span>
                                    </template>
                                    <h2>Saídas de Animais</h2>
                                </v-badge>
                            </div>
                            <v-spacer/>
                            <v-layout row wrap justify-end mr-1>
                                <v-btn id="adicionarSaidaAnimais" fab small dark color="#10303D" @click.prevent.stop="novaSaidaAnimais" style="margin:2px;">
                                    <v-icon dark small>fas fa-plus</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-layout row wrap justify-center>
                                <v-flex sm11 xs11 md12 lg12>
                                    <v-data-table :headers="headersSaidasAnimais" no-results-text="Nenhum registro encontrado"  @click:row="editSaidaAnimais"
                                        :items="outputs" color="secondary" loading-text="Carregando registros...aguarde">
                                        <template v-slot:item.dtSaida="{ item }">
                                            {{ item.dtSaida | dateIsoToLocale }}
                                        </template>
                                        <template v-slot:item.dtGta="{ item }">
                                            {{ item.dtGta | dateIsoToLocale }}
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-flex>
        </v-layout>

        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm :canSave="false" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>

    </AppMainSearchCard>
</template>

<script>

import AppMainSearchCard from '@/components/layout/AppMainSearchCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'

import { dateIsoToLocal, dateLocalToIso } from '@/filters/utils'
import { mapState } from 'vuex';

export default {
    name: 'LoteProducao',
    components: {
        AppMainSearchCard,
        AppMainActionsButtonsForm,
    },
    computed: {
        ...mapState(["listaGeneros"]),
        tituloTela () {
            return 'Dados do Lote de Produção: ' + this.loteProducaoStore.idLoteProducao
        },
        estabelecimentos () {
            return this.$store.state.estabelecimentos
        },
        loteProducaoStore () {
            return this.$store.state.loteProducaoAtual
        },
        listTiposAdministracao() {
          return [...this.$store.state.tiposAdmFarmaco, {dsTipo: "Ração", stTipo: "RC"}]
        }
    },
    data () {
        return {
            loteProducao: {},
            medicines: [],
            deaths: [],
            ration: [],
            outputs: [],
            inputs: [],
            totalMedicines: 0,
            totalDeaths: 0,
            totalRation: 0,
            totalOutputs: 0,
            totalInputs: 0,
            isLoadinglotesProducao: false,
            headersEntradasAnimais: [
                { text: "Origem", value: "nmOrigem" },
                { text: "Data de Entrada", value: "dtEntrada" },
                { text: "GTA", value: "nrGta" },
                { text: "Série", value: "dsSerieGta" },
                { text: "Data Emissão GTA", value: "dtGta" },
                { text: "Machos", value: "qtMachos" },
                { text: "Fêmeas", value: "qtFemeas" },
                { text: "Quantidade Total", value: "qtAnimais" },
                { text: "Existe divergência", value: "existeDivergencia" },
                { text: "Identificador", value: "idEntradaAnimais" },
            ],
            headersEntradasRacao: [
                { text: "Ração", value: "nmRacao" },
                { text: "Data de Entrada", value: "dtEntrada" },
                { text: "Quantidade (kg)", value: "qtRacao" },
                { text: "Início consumo", value: "dtInicioConsumo" },
                { text: "Fim consumo", value: "dtFimConsumo" },
                { text: "Medicada", value: "stMedicada"},
                { text: "Identificador", value: "idEntradaRacao" },
            ],
            headersMortalidades: [
                { text: "Motivo", value: "nmMortalidade" },
                { text: "Data", value: "dtBaixa" },
                { text: "Quantidade", value: "qtBaixa" },
                { text: "Gênero", value: "dsSexo" },
                { text: "Peso médio(kg)", value: "nrPeso" },
                { text: "Identificador", value: "idBaixa" },
            ],
            headersMedicines: [
                { text: "Medicamento", value: "farmaco.nmNome" },
                { text: "Início", value: "dtInicioTratamento" },
                { text: "Fim", value: "dtFimTratamento" },
                { text: "Fim carência", value: "dtCarencia" },
                { text: "Animais medicados", value: "qtAnimaisMedicados" },
                { text: "Dosagem", value: "dsDosagem" },
                { text: "Tipo", value: "dsTipoAdm" },
                { text: "Identificador", value: "idAdmFarmaco" },
            ],
            headersSaidasAnimais: [
                { text: "Data de Saída", value: "dtSaida" },
                { text: "GTA", value: "nrGta" },
                { text: "Série", value: "dsSerieGta" },
                { text: "Data Emissão GTA", value: "dtGta" },
                { text: "Machos", value: "qtMachos"},
                { text: "Fêmeas", value: "qtFemeas"},
                { text: "Quantidade Total", value: "qtAnimais" },
                { text: "Identificador", value: "idSaidaAnimais" },
            ],
        }
    },
    methods: {
        dateIsoToLocal,
        dateLocalToIso,
        novaEntradaAnimais () {
            this.$router.push({
                name: "loteEntradaAnimais",
                params: { idLote: this.loteProducaoStore.idLoteProducao }
            })
        },
        editEntradaAnimais (value) {
            this.$router.push({
                name: 'loteEntradaAnimais',
                params: {idLote: this.loteProducaoStore.idLoteProducao, id: value.idEntradaAnimais}
            })
        },
        novaEntradaRacao () {
            this.$router.push({
                name: "loteEntradaRacao",
                params: { idLote: this.loteProducaoStore.idLoteProducao }
            })
        },
        editEntradaRacao (value) {
            this.$router.push({
                name: 'loteEntradaRacao',
                params: {idLote: this.loteProducaoStore.idLoteProducao, id: value.idEntradaRacao}
            })
        },
        novaMortalidade () {
            this.$router.push({
                name: "loteBaixa",
                params: { idLote: this.loteProducaoStore.idLoteProducao }
            })
        },
        editMortalidade (value) {
            this.$router.push({
                name: 'loteBaixa',
                params: {idLote: this.loteProducaoStore.idLoteProducao, id: value.idBaixa}
            })
        },
        novoMedicamento () {
            this.$router.push({
                name: "loteAdmFarmacos",
                params: { idLote: this.loteProducaoStore.idLoteProducao }
            })
        },
        editMedicamento (value) {
            this.$router.push({
                name: 'loteAdmFarmacos',
                params: {idLote: this.loteProducaoStore.idLoteProducao, id: value.idAdmFarmaco}
            })
        },
        novaSaidaAnimais () {
            this.$router.push({
                name: "loteSaidaAnimais",
                params: { idLote: this.loteProducaoStore.idLoteProducao }
            })
        },
        editSaidaAnimais (value) {
            this.$router.push({
                name: 'loteSaidaAnimais',
                params: {idLote: this.loteProducaoStore.idLoteProducao, id: value.idSaidaAnimais}
            })
        },
        loadLoteProducao (id) {
            this.$axios.get("lote-producao/" + id)
                .then(response => {
                    this.loteProducao = response.data[0].data
                    var context = this
                    if (this.loteProducao.entradaRacao != null) {
                        context.ration = context.loteProducao.entradaRacao.sort((a, b) => {
                            return new Date(a.dtInicioConsumo) - new Date(b.dtInicioConsumo)
                        })

                        context.ration = context.ration.map(entry => {
                            let nmRacao = entry.racao.nmRacao
                            let stMedicada = entry.racao.stMedicada != undefined ? entry.racao.stMedicada == 'S' ? 'Sim' : 'Não' : 'Não'
                            return {...entry, nmRacao, stMedicada}
                        })
                        context.totalRation = context.ration.length
                    }

                    if (this.loteProducao.baixa != null) {
                        context.deaths = context.loteProducao.baixa.sort((a, b) => {
                            return new Date(b.dtBaixa) - new Date(a.dtBaixa)
                        })

                        context.deaths = context.deaths.map(entry => {
                            let nmMortalidade = entry.motivoBaixa != undefined ? entry.motivoBaixa.nmMotivoBaixa : 'Não Informado'
                            let dsSexo = ''
                            if (entry.sgSexo != null) {
                               dsSexo = context.listaGeneros.find(x => x.sgGenero == entry.sgSexo).dsGenero
                            }
                            return {...entry, nmMortalidade, dsSexo}
                        })
                        context.totalDeaths = context.deaths.length
                    }
                    
                    if (this.loteProducao.admFarmaco != null) {
                        context.loteProducao.admFarmaco.forEach(function(med) {
                            if (med.farmaco != null)
                            {
                                context.medicines.push(med)
                            }
                        })
                        context.medicines = context.medicines.sort((a, b) => {
                            return new Date(b.dtInicioTratamento) - new Date(a.dtInicioTratamento)
                        })

                        context.medicines = context.medicines.map(entry => {
                            let dtCarencia = new Date(entry.dtFimTratamento + 'T12:00:00Z')
                            if(entry.farmaco != null)
                                dtCarencia.setDate(dtCarencia.getDate() + entry.farmaco.nrDiasCarencia)
                            dtCarencia = dtCarencia.toISOString()
                            let dsDosagem = ''
                            let dsTipoAdm = context.listTiposAdministracao.find(x => x.stTipo == entry.csTipoAdm)['dsTipo']
                            if (entry.nrDosagem && entry.csTipoAdm != 'RC')
                            {
                                dsDosagem = entry.nrDosagem + ' ' + entry.farmaco.csUnidadeMedidaDosagem
                            }
                            return {...entry, dsDosagem, dtCarencia, dsTipoAdm}
                        })
                        context.totalMedicines = context.medicines.length
                    }

                    if (this.loteProducao.entradaAnimais != null) {
                        context.inputs = context.loteProducao.entradaAnimais.sort((a, b) => {
                            return new Date(b.dtEntrada) - new Date(a.dtEntrada)
                        })

                        context.inputs = context.inputs.map(entry => {
                            let estabelecimento = context.estabelecimentos.find(
                                x => x.idEstabelecimento == entry.cdEstabelecimentoOrigem
                            )
                            let nmOrigem = estabelecimento
                                ? estabelecimento.nmEstabelecimento
                                : 'Estabelecimento Deletado'
                            let divergencias = context.loteProducao.divergenciaEntradaAnimais.filter(x => x.cdEntradaAnimais == entry.idEntradaAnimais)
                            let existeDivergencia = divergencias.length > 0 ? 'Sim' : 'Não'
                            return {...entry, nmOrigem, existeDivergencia}
                        })
                        context.totalInputs = context.inputs.length
                    }

                    if (this.loteProducao.saidaAnimais != null) {
                        context.outputs = context.loteProducao.saidaAnimais.map(entry => {
                            return {...entry}
                        })
                        context.totalOutputs = context.outputs.length
                    }

                    context.$store.commit('mtChangeLoteProducaoAtual', context.loteProducao)
                })
                .catch((error) => {
                    this.$store.commit('setSnack', {type: 'error', msg : error})
                    this.$router.push({ path: '/lotes'})
                })
        },
        initViewFromRoute(route) {
            let id = route.params.id
            this.$store.dispatch('actLoadEstabelecimentos')
            if (id) {
                this.loadLoteProducao(id);
            } else {
                //load empty
            }
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
}

</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
